// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Util$SmartcutsMacros = require("../../../../bs-utils/src/Util.bs.js");
var UrlConstraint$SmartcutsMacros = require("../../UrlConstraint.bs.js");
var CommandContext$SmartcutsMacros = require("../../CommandContext.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("../../InterfaceBtwnRecordingAndPlayback.bs.js");

function urlCommandType_encode(v) {
  switch (v.TAG | 0) {
    case /* NewWindowWithUrlCommand */0 :
        return [
                "NewWindowWithUrlCommand",
                CommandContext$SmartcutsMacros.focusStatus_encode(v._0)
              ];
    case /* NewTabWithUrlCommand */1 :
        return [
                "NewTabWithUrlCommand",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v._0),
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v._1),
                CommandContext$SmartcutsMacros.focusStatus_encode(v._2)
              ];
    case /* URLCommand */2 :
        return [
                "URLCommand",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v._0)
              ];
    
  }
}

function urlCommandType_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NewTabWithUrlCommand" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = CommandContext$SmartcutsMacros.focusStatus_decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* NewTabWithUrlCommand */1,
                          _0: match$1._0,
                          _1: match$2._0,
                          _2: match$3._0
                        }
                      };
              }
              var e = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "NewWindowWithUrlCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = CommandContext$SmartcutsMacros.focusStatus_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NewWindowWithUrlCommand */0,
                      _0: v0._0
                    }
                  };
          }
          var e$3 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "URLCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* URLCommand */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$4 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function isDynamic(param) {
  if (param.urlConfig) {
    return true;
  } else {
    return false;
  }
}

var AuthoringConfig = {
  urlCommandType_encode: urlCommandType_encode,
  urlCommandType_decode: urlCommandType_decode,
  isDynamic: isDynamic
};

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "originalUrl",
                Decco.stringToJson(v.originalUrl)
              ],
              [
                "urlPattern",
                UrlConstraint$SmartcutsMacros.UrlPattern.t_encode(v.urlPattern)
              ],
              [
                "urlCommandType",
                urlCommandType_encode(v.urlCommandType)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var originalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalUrl"), null));
  if (originalUrl.TAG === /* Ok */0) {
    var urlPattern = UrlConstraint$SmartcutsMacros.UrlPattern.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlPattern"), null));
    if (urlPattern.TAG === /* Ok */0) {
      var urlCommandType = urlCommandType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlCommandType"), null));
      if (urlCommandType.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  originalUrl: originalUrl._0,
                  urlPattern: urlPattern._0,
                  urlCommandType: urlCommandType._0
                }
              };
      }
      var e = urlCommandType._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".urlCommandType" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = urlPattern._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".urlPattern" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = originalUrl._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".originalUrl" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromAuthoringConfig(config) {
  var urlPattern = config.urlConfig;
  if (urlPattern) {
    return {
            originalUrl: config.originalUrl,
            urlPattern: urlPattern._0,
            urlCommandType: config.urlCommandType
          };
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("URLConfig that ExactMatch can't be converted into a Smartcut.ParamDescriptor because it is not dynamic");
  }
}

var ParamDescriptor = {
  t_encode: t_encode,
  t_decode: t_decode,
  fromAuthoringConfig: fromAuthoringConfig
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "urlCommandType",
                urlCommandType_encode(v.urlCommandType)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
  if (url.TAG === /* Ok */0) {
    var urlCommandType = urlCommandType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlCommandType"), null));
    if (urlCommandType.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                url: url._0,
                urlCommandType: urlCommandType._0
              }
            };
    }
    var e = urlCommandType._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".urlCommandType" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".url" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify(param) {
  return "urlParam";
}

function fromParamDescriptor(param) {
  return {
          url: param.originalUrl,
          urlCommandType: param.urlCommandType
        };
}

var PlaybackParamValue = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify,
  fromParamDescriptor: fromParamDescriptor
};

exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* Util-SmartcutsMacros Not a pure module */
